function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.25 18.125V1.87501C1.25 1.52981 1.5298 1.25001 1.875 1.25001H11.25V3.75001C11.25 4.44036 11.8096 5.00001 12.5 5.00001H15V6.87501H16.25V4.37501C16.251 4.20888 16.1857 4.04919 16.0687 3.93126L12.3187 0.18126C12.2008 0.0642678 12.0411 -0.000927527 11.875 9.97262e-06H1.875C0.839453 9.97262e-06 0 0.839502 0 1.87501V18.125C0 19.1606 0.839453 20 1.875 20H6.25V18.75H1.875C1.52984 18.75 1.25 18.4702 1.25 18.125Z",
  fill: "#368B43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.19375 10.3437L7.5 11.725L6.80625 10.3437C6.70035 10.1336 6.48535 10.0007 6.25 10H5V11.25H5.8625L6.8 13.125L5.8625 15H5V16.25H6.25C6.48535 16.2493 6.70035 16.1164 6.80625 15.9063L7.5 14.525L8.19375 15.9063C8.29965 16.1164 8.51465 16.2493 8.75 16.25H10V15H9.1375L8.2 13.125L9.1375 11.25H10V10H8.75C8.51465 10.0007 8.29965 10.1336 8.19375 10.3437Z",
  fill: "#368B43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.125 12.5H16.875C16.5298 12.5 16.25 12.2202 16.25 11.875C16.25 11.5298 16.5298 11.25 16.875 11.25H18.125C18.4702 11.25 18.75 11.5298 18.75 11.875H20C20 10.8395 19.1605 10 18.125 10H16.875C15.8395 10 15 10.8395 15 11.875C15 12.9105 15.8395 13.75 16.875 13.75H18.125C18.4702 13.75 18.75 14.0298 18.75 14.375C18.75 14.7202 18.4702 15 18.125 15H16.875C16.5298 15 16.25 14.7202 16.25 14.375H15C15 15.4105 15.8395 16.25 16.875 16.25H18.125C19.1605 16.25 20 15.4105 20 14.375C20 13.3395 19.1605 12.5 18.125 12.5Z",
  fill: "#368B43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.875 10H10.625V15.625C10.625 15.9702 10.9048 16.25 11.25 16.25H14.375V15H11.875V10Z",
  fill: "#368B43"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgXls = function SvgXls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xls.338e47bb.svg";
export { ForwardRef as ReactComponent };